import { ContractTerm } from 'pricing/types';
import {
  getTermFinalCost,
  getTermFinalPrice,
  getTermInitialCost,
  getTermInitialPrice,
  getTermMiddleCost,
  getTermMiddlePrice,
} from 'pricing/utilities/contract/contractTerms/contractTermsPricing';

export const contractTermFormSetFieldsValue = (contractTerm: ContractTerm) => {
  return {
    breedId: contractTerm.breedId,
    breederContractTermTypeId: contractTerm.breederContractTermTypeId,
    colorIds: contractTerm.colors.map((color) => color.id),
    finalCost: getTermFinalCost(contractTerm),
    finalPrice: getTermFinalPrice(contractTerm),
    initialCost: getTermInitialCost(contractTerm),
    initialPrice: getTermInitialPrice(contractTerm),
    middleCost: getTermMiddleCost(contractTerm),
    middlePrice: getTermMiddlePrice(contractTerm),
    quantity: contractTerm.quantity,
    varietyIds: contractTerm.varieties.map((variety) => variety.id),
  };
};
